/*!
* @copyright
* Copyright(c) 2018 SICK AG
*/
const style = `* {
  box-sizing: border-box;
}

:host {
  font-size: 1rem;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  contain: content;
  border: 0;
  outline: 0;
  text-align: left;
  display: block;
  height: 100%;
}

.container {
  display: -webkit-box;
  display: flex;
  height: inherit;
  min-height: calc(60rem/14);
  padding: calc(18rem/14) calc(16rem/14);
}
.container .icon {
  display: block;
  height: calc(24rem/14);
  width: calc(24rem/14);
  margin-right: calc(8rem/14);
}
.container .text {
  line-height: 1.6;
}
.container.info {
  background-color: #e5f1f8;
  background-color: var(--davinci-color-information-primary-light, #e5f1f8);
}
.container.info .text {
  color: #007cc1;
  color: var(--davinci-color-text-on-information-primary-light, #007cc1);
}
.container.info .icon {
  fill: #007cc1;
  fill: var(--davinci-color-text-on-information-primary-light, #007cc1);
}
.container.success {
  background-color: #eff7e7;
  background-color: var(--davinci-color-success-light, #eff7e7);
}
.container.success .text {
  color: #63b017;
  color: var(--davinci-color-text-on-success-light, #63b017);
}
.container.success .icon {
  fill: #63b017;
  fill: var(--davinci-color-text-on-success-light, #63b017);
}
.container.error {
  background-color: #FCE6E9;
  background-color: var(--davinci-color-error-light, #FCE6E9);
}
.container.error .text {
  color: #EA0823;
  color: var(--davinci-color-text-on-error-light, #EA0823);
}
.container.error .icon {
  fill: #EA0823;
  fill: var(--davinci-color-text-on-error-light, #EA0823);
}
.container.warning {
  background-color: #FEF9E7;
  background-color: var(--davinci-color-warning-light, #FEF9E7);
}
.container.warning .text {
  color: #F5C413;
  color: var(--davinci-color-text-on-warning-light, #F5C413);
}
.container.warning .icon {
  fill: #F5C413;
  fill: var(--davinci-color-text-on-warning-light, #F5C413);
}`;
export { style };
//# sourceMappingURL=Callout.style.js.map